import { Component, OnInit } from '@angular/core';
import {UserService} from '../services/user.service';
import {Message} from 'primeng/primeng';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit {

  urlUpload: String;
  msgs: Message[] = [];
  user: any;
  blockedDocument: boolean = false;
  uploadedFiles: any[] = [];
  display: boolean = false;
  oldPassword : String;
  newPassword : String;
  confirmPassword : String;
  urlAvatar : String;

  constructor(private userService : UserService) { }

  ngOnInit() {
    this.user = this.userService.userLoged;
    this.urlUpload= this.userService.mainService.server_url+"user/saveProfilePicture/"+this.user.idUser;
    this.urlAvatar = this.userService.urlAvatar+'?' + (new Date()).getTime();;
  }

  edit(){
    this.blockedDocument = true;
    this.userService.edit(this.user).then(data =>{
      let response: any = data;
      if(response.status == 'OK'){
        this.userService.userLoged = this.user;
        this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      this.blockedDocument = false;
    });
  }

  showDialog(){
    this.display = true;
  }

  hide(){
    this.display = false;
  }

  changePassword(){
    if(this.newPassword != this.confirmPassword){
      this.msgs = [{severity:'error', summary:'ERROR', detail:"El nuevo Password no coincide"}];
      return;
    }
    if(this.newPassword == this.oldPassword){
      this.msgs = [{severity:'error', summary:'ERROR', detail:"El nuevo Password es igual al anterior"}];
      return;
    }
    this.blockedDocument = true;
    this.userService.changePassword(this.user.idUser,this.oldPassword,this.newPassword).then(data =>{
      let response: any = data;
      if(response.status == 'OK'){
        this.display = false;
        this.msgs = [{severity:'info', summary:'INFO', detail:'Password modificado exitosamente'}];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      this.blockedDocument = false;
    });
  }

  onUpload(event) {
    this.uploadedFiles = [];
    for (const file of event.files) {
      this.uploadedFiles.push(file);
    }
    let avatar = <HTMLImageElement>document.getElementById('avatar');
    avatar.src = this.userService.urlAvatar+'?' + (new Date()).getTime();
    this.urlAvatar = this.userService.urlAvatar+'?' + (new Date()).getTime();;

    this.msgs = [];
    this.msgs = [{severity:'info', summary:'INFO', detail:'Archivo subido exitosamente'}];
  }
}



// WEBPACK FOOTER //
// ./src/app/account/account.component.ts